import { genericResponse } from "../types/axios.types";
import { DivisionType, SurgeryRoomType } from "../types/general.types";
import { LoginForm, LoginResponse, UserInfoResponse, UserRoleResponse } from "../types/login.types";
import { baseHttp } from "./baseHttp";
import CookieService, { Cookies } from "./cookie.service";

const loginRequest = async (payload: LoginForm): Promise<genericResponse> => {
  const response: LoginResponse = await baseHttp.post(`/api/n/user/keycloak/monitor/login`, payload);
  if (response.status === 400) {
    console.log('Errore login: ', response.message)
    return { status: 500, message: response.message };
  }
  if (response.data?.access_token) {
    CookieService.setToken(Cookies.TOKEN, response.data?.access_token, 7);
    return { status: 200, message: '' };
  }
  return { status: 500, message: 'ERROR' };
};

const retrieveUserInRole = async (username?: string): Promise<UserRoleResponse> => {
  const usernameFilter = username ? `&includeUsername=${username}` : '';
  return baseHttp.get(`/api/n/user/all/role?isActiveUser&isValidUser${usernameFilter}`).then((response: any) => response.data);
};

const retrieveLoggedUserInfo = async (): Promise<UserInfoResponse> => {
  return baseHttp.get(`/api/n/roles/user/permission`).then((response: any) => response.data)
}

const retrieveSurgeryRoomList = async (): Promise<{ list: SurgeryRoomType[], page: string, pageSize: string, totalResults: number }> => { //Promise<LookupGeneralType[]>
  const payload = [{ field: "t.validityEnd", value: "undefined", operator: "isValid" }]
  return baseHttp.post(`/api/n/surgery-room/roomblocks/filter?q=1&take=100&page=1`, payload).then((response: any) => response.data)
}

const retrieveDivisionList = async (): Promise<{ list: DivisionType[], page: string, pageSize: string, totalResults: number }> => { 
  const payload = [{ field: "t.validityEnd", value: "undefined", operator: "isValid" }]
  return baseHttp.post(`/api/n/division/filter?q=1&take=100&page=1`, payload).then((response: any) => response.data)
}

const AuthService = {
  loginRequest,
  retrieveUserInRole,
  retrieveLoggedUserInfo,
  retrieveSurgeryRoomList,
  retrieveDivisionList
}

export default AuthService;
